<template>
  <div>
    <div class="container-fluid" style="height: 65px">
            <form>
            
             
            
              <div class="row">
                <b-card
                  style="
                    border: solid 1px #f5a623;
                    padding: 0px;
                    width: 100%;
                    margin-left: 1rem !important;
                    margin-right: 1rem !important;
                    background-color: #ebedef !important;
                  "
                >
                <div class="row">
                <div class="col-md-4 col-sm-12">
                  <div  class="form-group">
                 <label>Raison Sociale</label> 
                    <input
                      aria-label="label"
                      type="text"
                      required
                      class="form-control personalise"
                      placeholder="Raison Sociale *"
                      v-model="retenue.raison_sociale"
                    />

                   
                  </div>
                </div>
                <div class="col-md-4 col-sm-12">
                  <div  class="form-group">
                   <label>Adresse</label> 
                    <input
                      aria-label="label"
                      type="text"
                      required
                      class="form-control personalise"
                      placeholder="Adresse *"
                      v-model="retenue.adresse"
                    />

                   
                  </div>
                </div>
                <div class="col-md-4 col-sm-12">
                  <div  class="form-group">
                   <label>Identification Fiscale</label> 
                    <input
                      aria-label="label"
                      type="text"
                      required
                      class="form-control personalise"
                      placeholder="Identification Fiscale *"
                      v-model="retenue.idFisclae"
                    />

                
                  </div>
                </div>
              
              </div>
            
              <div class="row">
              <!--   <div class="col-md-6 col-sm-12">
             

                  <div class="form-group">
                 
                    <input
                      aria-label="label"
                      type="date"
                      class="form-control personalise"
                      placeholder="Date *"
                      v-model="retenue.date"
                    />

                
                  </div>
                </div> -->
                <div class="col-md-12 col-sm-12">
                  <div class="form-group">
                     <label>Monat Bruts</label> 

                    <input
                    required
                      aria-label="label"
                      type="number"
                      class="form-control personalise"
                      placeholder="Monat Bruts *"
                      v-model="retenue.monat_bruts"
                    />

               
                  </div>
                </div>
              </div>
              <div class="row">
                <CCol sm="12 w-100 m-0">
                    <div class="form-group">
                     

                      <VueDatePicker
                      required
                        class="form-control"
                        v-model="selectedDate"
                        
                      />
                    </div>
                  </CCol>
              </div>

                

                 


                  <CButton
                   
                    @click.prevent="create"
                    type="submit"
                    size="sm"
                    color="warning"
                    style="border-radius: 24px; margin-left: 22px"
                    ><CIcon name="cil-check-circle" /> Ajouter</CButton
                  >
                </b-card>
              </div>
            </form>
          </div>
  </div>
</template>


<style lang="scss" scoped>
.md-card {
  width: 98%;
  margin: 4px;
  margin-left: 11px;
  display: inline-block;
  vertical-align: top;
}
</style>


<script lang="ts">
import Vue from "vue";
import { VueDatePicker } from "@mathieustan/vue-datepicker";
import "@mathieustan/vue-datepicker/dist/vue-datepicker.min.css";
import { apiDomain } from "../../config";
import axios from "axios";
export default {
  components: { VueDatePicker },
  name: "register",
  data() {
    return {
     
      retenue:{},
      selectedDate: new Date().toISOString().split("T")[0],

     
    };
  },
  created() {
    this.get_societe_services();
    this.fetch_get_matrs_okba();
     this.fetch_get_last_num_fac();
  },
  mounted() {},
  computed: {
    MontantmonatBruts(){
        var res =Number(this.retenue.monat_bruts);
     return  res;

    },
    MontantRet(){
        var res = (Number(this.retenue.monat_bruts)/100);
     return  res;

    },
    MontantNets(){
      return Number(this.retenue.monat_bruts) - Number(this.MontantRet);
    },
    /* ---------------------- */
    VrtguleMontantmonatBruts(){
        var res =Number(this.retenue.monat_bruts).toString();
        var formatted =res.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
     return  formatted;

    },
    VrtguleMontantNets(){
        var res =this.MontantNets.toString();
        var formatted =res.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
     return  formatted;

    },
    VrtguleMontantRet(){
        var res =this.MontantRet.toString();
        var formatted =res.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
     return  formatted;

    },
    
  },
  methods: {
   
    create(e) {
      let formData = new FormData();
      formData.append("date", this.selectedDate);

      formData.append("raison_sociale", this.retenue.raison_sociale);
      formData.append("adresse", this.retenue.adresse);
      formData.append("idFisclae", this.retenue.idFisclae);

      formData.append("monat_bruts", this.VrtguleMontantmonatBruts);
      formData.append("montant_nets", this.VrtguleMontantNets);
      formData.append("monatant_ret", this.VrtguleMontantRet);

      
      axios
        .post(`${apiDomain}/api/retenue`, formData)

        .then((res) => {
          this.$noty.success("Retenue Ajouter avec Succès ! ");

          this.$router.push("/listesRetenues");

          // this.fetchsearch();
        })
        .catch((error) => {
          if (error.response.status == 422) {
            this.errors = error.response.data.errors;
            this.$noty.error("OOPS ! il y a une erreur essayé de vérifier ");
          }
          if (error.response && error.response.status == 400) {
            this.validationErrors = error.response.data;
          }
        });
    },

    addNewProgramme: function () {
      this.programmes.push(Vue.util.extend({}, this.programme));
    },

    onSelect(Sous_categorie) {
      this.programmes.push(Sous_categorie);
      this.sCats3.push(detail);

      console.log(this.programmes);
    },
    //detaile push
    onSelectDetails(detail) {
      this.sCats3.push(detail);
      this.qts.push(detail);

      console.log(this.sCats3);
    },

    //Qts push
    onSelectQts(initial_qts) {
      this.qts.push(initial_qts);
      //console.log(this.qts);
      // this.programmes.push(Vue.util.extend({}, this.detaille));
    },

    addNewQTS: function () {
      this.qts.push(Vue.util.extend({}, this.qt));
    },

    showEditModalDetails(detail, index) {
      let obj = {
        // id: Sous_categorie.id,
        detail_services_id: detail.Type,
      };
      this.detailleDetails = obj;
      this.showdetailleModale = true;
      this.index = index;
    },

    showdetailleDetails(detail) {
      this.detailleDetails = detail;
      this.showdetailleModaleDetails = true;
    },

    /* fin detail push */
    showEditModal(Sous_categorie, index) {
      let obj = {
        // id: Sous_categorie.id,
        titre: Sous_categorie.titre_sc,
        description: Sous_categorie.image_sc,
      };
      this.detaille = obj;
      this.showdetailleModale = true;
      this.index = index;
    },

    showdetaille(Sous_categorie) {
      this.detaille = Sous_categorie;
      this.showdetailleModale = true;
    },

    //qts
    /*  showEditModalDetails(qt, index) {
      let obj = {
        // id: Sous_categorie.id,
        qts: qt.qts,
      };
      this.detailleQts = obj;
      this.showdetailleModale = true;
      this.index = index;
    },

    showdetailleDetails(qt) {
      this.detailleDetails = qt;
      this.showdetailleModaleQts = true;
    }, */

    getCategories() {
      axios
        .get(`${apiDomain}/api/listeCtegoriesSubCategg`)

        .then((res) => {
          this.Cats = res.data;
          //this.cat = false;
        })
        .catch((err) => console.log(err));
    },

    /*   fetchCatTypes3() {
      axios
        .get(`${apiDomain}/api/fetchCatTypes3`)

        .then((res) => {
        
          this.detail_services = res.data;
          //this.cat = false;
        })
        .catch((err) => console.log(err));
    }, */

    fetchCatTypes3(id) {
      axios.get(`${apiDomain}/api/getTypes3/${id}`).then(({ data }) => {
        this.sCats33 = data.sous_cat;
        // this.nameFatherCat = data.cat.titreCategorie;
      });
    },

    get_societe_services() {
      axios
        .get(`${apiDomain}/api/all_societe`)

        .then((res) => {
          this.all_societe = res.data;
          //this.cat = false;
        })
        .catch((err) => console.log(err));
    },

    fetch_get_last_num_fac() {
      axios.get(`${apiDomain}/api/get_last_num_fac`).then(({ data }) => {
        this.last_num_fac = data.num_fac[0];
      
      });
    },

    fetch_get_matrs_okba() {
      axios.get(`${apiDomain}/api/get_matrs/1`).then(({ data }) => {
        this.options_okba = data.sous_cat;
        if (data.cat.nom != "Client passagé") {
          this.nom_chouffeur = data.cat.nom;
        }
      });
    },
    fetch_get_matrs(id) {
      axios.get(`${apiDomain}/api/get_matrs/${id}`).then(({ data }) => {
        this.options = data.sous_cat;
        if (data.cat.nom != "Client passagé") {
          this.nom_chouffeur = data.cat.nom;
        }
      });
    },

    fetchCatTypes(id) {
      axios.get(`${apiDomain}/api/getTypes/${id}`).then(({ data }) => {
        this.sCats = data.sous_cat;
        // this.nameFatherCat = data.cat.titreCategorie;
      });
    },
  },
};
</script>


<style lang="scss" >
.glow-on-hover {
  width: 90px;
  height: 76px;
  border: none;
  outline: none;
  color: #fff;
  background: #24b2dc;
  cursor: pointer;
  position: relative;
  z-index: 0;
  border-radius: 10px;
}

.glow-on-hover:before {
  content: "";
  /*   background: #20b3b3;
  color: #fff; */
  background: linear-gradient(
    45deg,
    #ff0000,
    #ff7300,
    #fffb00,
    #48ff00,
    #00ffd5,
    #002bff,
    #7a00ff,
    #ff00c8,
    #ff0000
  );
  position: absolute;
  top: -2px;
  left: -2px;
  background-size: 400%;
  z-index: -1;
  filter: blur(5px);
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  animation: glowing 20s linear infinite;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  border-radius: 10px;
}

.glow-on-hover:active {
  color: #000;
}

.glow-on-hover:active:after {
  background: transparent;
}

.glow-on-hover:hover:before {
  opacity: 1;
}

.glow-on-hover:after {
  z-index: -1;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: #de8e15;
  left: 0;
  top: 0;
  border-radius: 10px;
}

@keyframes glowing {
  0% {
    background-position: 0 0;
  }
  50% {
    background-position: 400% 0;
  }
  100% {
    background-position: 0 0;
  }
}

/* ***** */
.custom-input {
  text-align: center;
  color: #fff;
  font-weight: bold;
  font-size: 1.4em;
  background-color: #341677;
}

.vs__dropdown-toggle {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 0 0 4px 0;

  /* border: 1px solid rgba(60, 60, 60, 0.26); */
  border-radius: 4px;
  white-space: normal;
  /* border: 1px solid #333; */
  border: solid 1px #f5a623 !important;
  background: #fff !important;
  height: 37px !important;
}

.nav-tabs {
  border-bottom: 1px solid;
  border-color: #c4c9d0;
  margin-left: 42px !important;
}
</style>



